<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{anwendungsname}}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Hilfe</h4>
    </div>
  </div>
  <mat-card>
    <h5>Auswahl der Indikatoren</h5>

    Über die Reiter „Tierwohlindikatoren“ und „Tierwohl-Begleitindikatoren“
    können Sie wählen, ob Sie Indikatoren zu einzelnen Tierarten oder die
    Rahmenbedingungen für das Tierwohl in Deutschland beschreibende Indikatoren
    anzeigen lassen möchten. Sie können frei wählen, welche Kriterien Sie
    miteinander kombinieren möchten. Wenn Sie die Voreinstellung der
    Web-Anwendung übernehmen – also nichts auswählen, werden Ihnen im nächsten
    Schritt alle Indikatoren angezeigt. In der obersten Zeile aktualisiert sich
    die Zahl der ausgewählten und im nächsten Schritt angezeigten Indikatoren
    live, basierend auf Ihrer Filterauswahl. Sobald Sie in einem der Kriterien
    eine Auswahl treffen, verringert sich die Zahl der Indikatoren. Wenn Sie
    Ihre Filter gewählt haben, klicken Sie auf „Weiter“, um die Indikatorenliste
    anzuzeigen.

    <br />
    <br />
    <h6>REITER TIERWOHLINDIKATOREN</h6>

    Die Anwendung bietet beim Start standardmäßig alle Indikatoren an. Durch das
    Setzen von Filtern, können Sie die Indikatorenauswahl verringern. Sie können
    die Filter beliebig setzen. Das gilt sowohl innerhalb der Container
    „Tierart“, „Abschnitt, Dimension, Bezug“ und „Themenbereiche“ als auch
    containerübergreifend. Im Container „Themenbereiche“ wird Ihnen hinter dem
    Themenbereich in Klammern die Zahl der jeweils aktuell enthaltenen
    Indikatoren angezeigt. Durch die Auswahl ausgeschlossene Themenbereiche sind
    ausgegraut. i-Buttons bieten Hintergrundinformationen.
    <br />
    <br />
    <h6>REITER TIERWOHL-BEGLEITINDIKATOREN</h6>

    Sie können bis zu vier Themenbereiche in beliebiger Kombination auswählen:
    „Rechtliche Rahmenbedingungen“, „Förderung“, „Konsum“ und „Produktion“.
    Weitere Informationen zu den Tierwohl-Begleitindikatoren finden Sie unter
    FAQ:
    <a href="/faq/#GesondertGelistet"
      >„Was sind Tierwohl-Begleitindikatoren und warum werden sie gesondert
      gelistet?“</a
    >

    <br />
    <br />
    <h5>Ansicht Ergebnisliste der Indikatoren</h5>

    Sie erhalten hier eine Übersicht aller Indikatoren, die Sie im vorherigen
    Schritt ausgewählt haben. Am linken Bildschirmrand können Sie entscheiden,
    für welche Tierart und Nutzungsrichtung (Tierwohl-Begleitindikatoren:
    Themenbereich) Sie die Indikatoren sehen möchten. Durch Klick auf „˅“
    klappen Sie die Nutzungsrichtungen aus. Hinter jedem Begriff finden Sie die
    jeweils enthaltene Indikatorenanzahl. In der Tabelle sehen Sie je Zeile
    einen Indikator mit dazugehöriger Quelle, Tierwohl-Dimension und
    Identifikationsnummer. Um eine Kurzbeschreibung des Indikators anzuzeigen,
    fahren Sie mit der Maus über den Infobutton „i“. Durch Klicken auf die
    Pfeile neben den Spaltenüberschriften können Sie die Tabelle alphabetisch
    sortieren. Unter „Indikatoren je Seite“ können Sie die Anzahl der
    angezeigten Treffer pro Seite bestimmen. Mithilfe des Kästchens „Zeige
    doppelte Einträge in Tabelle“ oberhalb der Tabelle können Sie wählen, ob Sie
    mehrfach vorkommende Indikatoren ein- oder ausblenden möchten. Siehe dazu
    auch unter FAQ die Frage:     <a href="/faq/#WarumMehrfach"
    >„Warum sind manche Indikatoren mehrfach
    aufgeführt?“</a
  >

    <br />
    <br />
    <h5>Datenausgabe</h5>
    Jeder in der Datenbank enthaltene Indikator wird als Steckbrief in einer
    PDF-Datei beschrieben. Im Steckbrief finden Sie neben der Kurzbeschreibung
    des Indikators u.a. Informationen über Methoden der Datenerhebungen und die
    Datenverfügbarkeit in Deutschland. Zum Herunterladen einzelner
    Indikatorsteckbriefe als PDF-Datei klicken Sie rechts auf das
    Download-Symbol. Um mehrere Indikatorsteckbriefe gleichzeitig
    herunterzuladen, markieren Sie diese mithilfe der Kästchen in der linken
    Spalte und klicken Sie anschließend unterhalb der Tabelle auf „Download
    ausgewählte Datensätze“.

    <h5></h5>
    <!--Wegen Formatierung drinnen, nicht wegnehmen sonst ist bei    <h5>Datenausgabe</h5> ein Abstand nicht drinnen-->
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
